/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Asset, Asset$inboundSchema } from "./asset.js";

export type UploadChatAttachmentResult = {
  asset: Asset;
  /**
   * The URL to serve the chat attachment
   */
  url: string;
};

/** @internal */
export const UploadChatAttachmentResult$inboundSchema: z.ZodMiniType<
  UploadChatAttachmentResult,
  unknown
> = z.object({
  asset: Asset$inboundSchema,
  url: z.string(),
});

export function uploadChatAttachmentResultFromJSON(
  jsonString: string,
): SafeParseResult<UploadChatAttachmentResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UploadChatAttachmentResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UploadChatAttachmentResult' from JSON`,
  );
}
